import RestClient from '../../config/rest-client';
import errorMessage from '../../lib/errorMessage';

export async function getQuizStatistic(quiz_id) {
  try {
    return await RestClient.post('quiz', 'statistic', {quiz_id})
  } catch (error) {
    errorMessage(error)
  }
}